// const BASE_URL = "http://localhost:5000";
//const BASE_URL = "http://159.65.146.120:5005"; //for http
const BASE_URL = "https://perk-api.imedclust.com"; //for https

module.exports = {
  BASE_URL
};
